<ion-header [translucent]="true" *ngIf="detail">
  <ion-toolbar>
    <ion-buttons slot="start" *ngIf="isPage">
      <app-back-button defaultHref="home"></app-back-button>
    </ion-buttons>
    <ion-buttons slot="end" *ngIf="!isPage">
      <ion-button (click)="close()"><ion-icon name="close-outline"></ion-icon></ion-button>
    </ion-buttons>
    <ion-buttons slot="start" *ngIf="!isPage">
      <ion-button (click)="shareDetail(detail.id)"><ion-icon name="share-outline"></ion-icon></ion-button>
    </ion-buttons>
    <ion-buttons slot="end" *ngIf="isPage">
      <ion-button (click)="shareDetail(detail.id)"><ion-icon name="share-outline"></ion-icon></ion-button>
    </ion-buttons>
    <ion-title><app-logo [height]="30"></app-logo></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" *ngIf="detail">
  <ion-header collapse="condense">
    <ion-toolbar>
      <ion-title size="large">{{detail.name}}</ion-title>
    </ion-toolbar>
  </ion-header>
  <app-db-exercise-img [img1]="detail.images[0]" [img2]="detail.images[1]"></app-db-exercise-img>

  <ion-card *ngIf="detail">
    <ion-card-content>
      <ion-list lines="none">
        <ion-item>
          <ion-label>Force: {{ detail.force }}</ion-label>
        </ion-item>
        <ion-item>
          <ion-label>Level: {{ detail.level }}</ion-label>
        </ion-item>
        <ion-item>
          <ion-label>Mechanic: {{ detail.mechanic }}</ion-label>
        </ion-item>
        <ion-item>
          <ion-label>Equipment: {{ detail.equipment }}</ion-label>
        </ion-item>
        <ion-item>
          <ion-label>Category: {{ detail.category }}</ion-label>
        </ion-item>
        <ion-item>
          <ion-label>Primary Muscles:</ion-label>
          <div>
            <ion-chip *ngFor="let muscle of detail.primaryMuscles">
              <ion-label>{{ muscle }}</ion-label>
            </ion-chip>
          </div>
        </ion-item>
        <ion-item>
          <ion-label>Secondary Muscles:</ion-label>
          <div>
            <ion-chip *ngFor="let muscle of detail.secondaryMuscles">
              <ion-label>{{ muscle }}</ion-label>
            </ion-chip>
          </div>
        </ion-item>
      </ion-list>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-content>
      <p *ngFor="let instruction of detail.instructions">{{instruction}}</p>
    </ion-card-content>
  </ion-card>

  <ion-button
    *ngIf="isPage && (null | authState | async) !== null"
    expand="block"
    fill="outline"
    (click)="addExercise(detail)"
    class="px py"
  >
    Save exercise to library
  </ion-button>

</ion-content>
